<template>

  <v-container fluid class="page page-credit-list">

    <!-- Breadcrumb -->
    <v-row class="mt-4 mb-8">
      <v-col cols="12" class="d-flex align-center justify-start page-breadcrumb-new">
        <v-icon small class="mr-2">mdi-credit-card</v-icon>
        <div>Credits</div>
      </v-col>
    </v-row>

    <!-- Page Content -->
    <v-container fluid class="px-0">
      <!-- Issued Credits (DELIVERED) -->
      <order-list-data-table
          title="Issued Credits"
          defaultSortField="delivered_at"
          defaultSortOrder="dsc"
          :headers="headers"
          :status="status"
          :credits="true"
          :assocs="assocs"
          :linkToLocations="true" />
    </v-container>

  </v-container>

</template>

<script>
import OrderListDataTable from '@/components/orders/OrderListDataTable'

export default {
  name: 'CreditListPage',

  components: {
    OrderListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Order#', value: 'order_number', width: '180px' },
        // { text: 'Provider', value: 'provider_alias' },
        // { text: 'Account', value: 'thirdparty_account_name' },
        { text: 'Brand', width: '140px', value: 'thirdparty_brand_name' },
        { text: 'Total', value: 'order_details.total' },
        { text: 'From', value: 'shipper.name' },
        { text: 'To', value: 'receiver.name' },
        { text: 'Issued', value: 'delivered_at' }
      ],
      status: ['DELIVERED'],
      assocs: 'shipper,receiver,order_details,parent_order'
    }
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    }
  }
}
</script>

<style>
</style>
